import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Initialize monitoring in production
import "./lib/monitoring";
import { measurePerformance, trackBundleSize } from "./lib/performance";

// Performance monitoring
if (import.meta.env.PROD) {
  measurePerformance();
  trackBundleSize();
}

createRoot(document.getElementById("root")!).render(<App />);
